import { gql, useMutation } from '@apollo/client'

export const UPDATE_PROJECT_TEAM_INFO = gql`
  mutation ($input: CampaignUpdateTeamInfo) {
    updateCampaignTeamInfo(input: $input) {
      id
    }
  }
`

export const useUpdateProjectTeamInfo = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_PROJECT_TEAM_INFO, {
    update(cache) {
      cache.modify({
        fields: {
          getCampaign() {},
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
